import script from "./employees-list.vue?vue&type=script&setup=true&lang=js"
export * from "./employees-list.vue?vue&type=script&setup=true&lang=js"

import "./employees-list.vue?vue&type=style&index=0&id=03f1b70d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03f1b70d"]])

export default __exports__